import http from './utils';
import { prefix, mockPrefix } from './constants';
// 主页:
export function getWeeklyEffectList(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/effect_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
export function getWeeklyVersionStat(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/version_stat`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
export function getVersionLineChartStat(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/version_line_chart_stat`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 执行进度
export function getWeeklyVersionImplement(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/get_implement`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
export function saveWeeklyVersionImplement(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/save_implement`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 洞察分析
export function getWeeklyVersionSummary(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/get_summary`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
export function saveWeeklyVersionSummary(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/update_summary`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 洞察分析 UGC富文本
export function getWeeklyVersionUGCSummary(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/ugc_video_summary `,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
export function saveWeeklyVersionUGCSummary(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/save_ugc_video_summary `,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
// 洞察分析 UGC视频
export function getWeeklyVersionUGCVideo(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/ugc_video_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 配置页:
// 处理版本新增、编辑、删除
export function handleWeeklyVersion(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/save`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 处理模块新增、编辑、删除
export function handleWeeklyVersionModel(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version_module/save`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 获取版本列表
export function getWeeklyVersionList(payload: any) {
  return http({
    url: `${prefix}/weekly_report/version/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

export const getWeeklyReportVersionLineChartStat: (
  payload: any,
) => Promise<any> | any = payload =>
  http({
    url: `${prefix}/weekly_report/version/version_line_chart_stat`,
    method: 'post',
    ...payload,
  });

export const getWeeklyReportVersionModuleRankSave: (
  payload: any,
) => Promise<any> | any = payload =>
  http({
    url: `${prefix}/weekly_report/version_module/rank_save`,
    method: 'post',
    ...payload,
  });
